module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Red Sox in the Hall of Fame")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "template.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title-head",
    attrs: {
      "id": "Ack"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("A project of this magnitude would not be possible without the help of a very supportive lineup. A heartfelt thanks to the following people for their input and assistance: Sam Hickey for his artistic creativity; Ray Sinibaldi for his insight, numerous suggestions, and resources; Rachael Adams for her patience and editorial support; Danny O’Brien for his annual trek to Cooperstown and photography skills; diehard Red Sox fan Ernie Spadaro for swinging for the fences; Pati and Sox for their unwavering loyalty and companionship; Jeff Ruetsche, acquisitions editor at Arcadia Publishing, for his shared vision for this project; Caitrin Cunningham, senior title manager at Arcadia Publishing, for her professionalism and guidance; the entire staff at Arcadia Publishing; Sara Coffin, curator, Boston Red Sox; Cassidy Lent of the National Baseball Library (NBL); Bill Nowlin; Glenn Stout; the Society for American Baseball Research; "), _c('a', {
    attrs: {
      "href": "http://baseball-reference.com",
      "target": "_blank"
    }
  }, [_vm._v("baseball-reference.com")]), _vm._v("; "), _c('a', {
    attrs: {
      "href": "http://fenwaypark100.org",
      "target": "_blank"
    }
  }, [_vm._v("fenwaypark100.org")]), _vm._v("; and all the people past and present who shared their love for the Boston Red Sox, its greatest players, and the Baseball Hall of Fame through their lenses. Unless otherwise noted, all images are from author David Hickey’s private collection.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-313efe6a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Acknowledgments.vue
// module id = 75
// module chunks = 0